import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { LayoutService } from '@app/shared/ui/layout.service';
import { EventService } from '../../core/services/event.service';


@Component({
    selector: 'app-vertical',
    templateUrl: './vertical.component.html',
    styleUrls: ['./vertical.component.scss'],
    standalone: false
})

/**
 * Vertical component
 */
export class VerticalComponent implements OnInit, AfterContentChecked {

    isCondensed = false;
    // sidebartype: string;
    hideMenu: boolean = false;

    constructor(private router: Router, private eventService: EventService,
        private layoutService: LayoutService, private cdref: ChangeDetectorRef) {
        this.router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                document.body.classList.remove('sidebar-enable');
            }
        });

        this.layoutService.fullScreenMode$.subscribe((fullScreen: boolean) => {
            this.hideMenu = fullScreen;
        });
    }

    ngOnInit() {
        // this.sidebartype = SIDEBAR_TYPE;
        // listen to event and change the layout, theme, etc
        // this.eventService.subscribe('changeSidebartype', (layout) => {
        //   this.sidebartype = layout;
        //   this.changeSidebar(this.sidebartype);
        // });

        // this.changeSidebar(this.sidebartype);

        document.body.setAttribute('data-layout', 'vertical');
    }

    isMobile() {
        const ua = navigator.userAgent;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    /**
     * On mobile toggle button clicked
     */
    onToggleMobileMenu() {
        this.isCondensed = !this.isCondensed;
        document.body.classList.toggle('sidebar-enable');
        document.body.classList.toggle('vertical-collpsed');

        if (window.screen.width <= 768) {
            document.body.classList.remove('vertical-collpsed');
        }
    }


}
